<template>
  <div class="ai-sales-assistant">
    <div class="container">
      <div class="header">
        <h1>AI采购助手</h1>
        <p>智能化采购管理解决方案，提升采购效率，降低采购成本，优化供应链管理</p>
      </div>

      <div class="modules-grid">
        <div 
          v-for="(module, key) in modules" 
          :key="key"
          class="module-card" 
          :class="key"
          @click="openModal(key)"
        >
          <div class="module-icon" :class="key">{{ module.icon }}</div>
          <h3 class="module-title">{{ module.title }}</h3>
          <p class="module-description">{{ module.description }}</p>
          <ul class="feature-list">
            <li v-for="feature in module.features" :key="feature">{{ feature }}</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 弹窗模态框 -->
    <div v-if="showModal" class="modal" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <span class="modal-title">{{ selectedModule.title }}</span>
          <span class="close" @click="closeModal">&times;</span>
        </div>
        <div class="modal-body">
          <div class="function-overview">
            {{ selectedModule.overview }}
          </div>
          
          <div class="core-functions">
            <h3>核心功能</h3>
            <div class="function-grid">
              <div 
                v-for="func in selectedModule.functions" 
                :key="func.name"
                class="function-item"
              >
                <div class="function-icon">{{ getFunctionIcon(func.name) }}</div>
                <div class="function-content">
                  <h4>{{ func.name }}</h4>
                  <p>{{ func.description }}</p>
                </div>
              </div>
            </div>
          </div>
          
          <div class="core-advantage">
            <h3>核心优势</h3>
            <p>{{ selectedModule.advantage }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AISalesAssistant',
  data() {
    return {
      showModal: false,
      selectedModuleKey: '',
      modules: {
        market: {
          icon: '',
          title: '',
          description: '',
          features: [
            // '行业信息搜索',
            // '客户信息挖掘',
            // '竞争对手分析',
            // '供应链信息'
          ]
        },
        sales: {
          icon: '',
          title: '',
          description: '',
          features: [
            // '客户画像分析',
            // '推广资料定制',
            // '邮件营销',
            // '短信推广'
          ]
        },
        materials: {
          icon: '',
          title: '',
          description: '',
          features: [
            // '销售资料整理',
            // '产品资料库',
            // '行业信息汇总',
            // '智能搜索'
          ]
        },
        promotion: {
          icon: '',
          title: '',
          description: '',
          features: [
            // '公众号软文创作',
            // '视频内容制作',
            // '内容发布管理',
            // '传播效果分析'
          ]
        },
        sop: {
          icon: '',
          title: '',
          description: '',
          features: [
            // '客户开发流程',
            // '需求挖掘方法',
            // '产品推荐策略',
            // '异议处理技巧'
          ]
        }
      },
      moduleData: {
        market: {
          title: '市场调研',
          overview: '智能搜索行业信息、客户信息、竞争对手信息等，快速获取有价值的市场情报和联系方式',
          functions: [
            {
              name: '行业信息搜索',
              description: '智能搜索行业动态、市场趋势、政策法规等信息，帮助销售人员快速了解市场环境'
            },
            {
              name: '客户信息挖掘',
              description: '通过多维度数据分析，挖掘潜在客户信息，包括企业基本信息、经营状况、联系方式等'
            },
            {
              name: '竞争对手分析',
              description: '收集竞争对手的产品信息、价格策略、市场份额等，为制定销售策略提供参考'
            },
            {
              name: '供应链信息',
              description: '分析客户上下游信息和供应商网络，识别商业机会和合作伙伴'
            },
            {
              name: '供应商资源',
              description: '整理优质供应商信息，建立供应商数据库，支持业务拓展和成本优化'
            },
            {
              name: '展会信息汇总',
              description: '实时更新行业展会信息，包括时间、地点、参展商等，帮助把握商机'
            }
          ],
          advantage: '基于大数据和AI算法的深度分析，确保获得最优质的市场信息和客户线索。'
        },
        sales: {
          title: '精准推销',
          overview: '基于客户画像进行精准推销，自动整理推广资料，通过多渠道进行智能化客户触达',
          functions: [
            {
              name: '客户画像分析',
              description: '基于客户数据构建详细画像，分析客户需求、偏好和购买行为，实现精准营销'
            },
            {
              name: '推广资料定制',
              description: '根据不同客户需求自动生成定制化推广资料，包括产品介绍、解决方案等'
            },
            {
              name: '邮件营销',
              description: '批量发送个性化邮件，优化邮件营销效果'
            },
            {
              name: '短信推广',
              description: '智能短信群发，支持个性化内容和定时发送，提高客户触达效率'
            },
            {
              name: '电话营销支持',
              description: '为销售人员提供话术建议和客户信息，提升电话营销成功率'
            }
          ],
          advantage: '基于AI算法的精准客户匹配，实现个性化推销，大幅提升成交概率。'
        },
        materials: {
          title: '资料管理',
          overview: '智能整理和管理销售资料、产品资料、行业信息，建立知识库，提升信息利用效率',
          functions: [
            {
              name: '销售资料整理',
              description: '自动整理和分类销售相关资料'
            },
            {
              name: '产品资料库',
              description: '建立完整的产品资料库'
            },
            {
              name: '行业信息汇总',
              description: '收集整理行业报告、市场分析、竞品信息等行业资料'
            },
            {
              name: '智能搜索',
              description: '提供强大的搜索功能，快速找到所需资料，提高工作效率'
            },
            {
              name: '知识库管理',
              description: '建立企业知识库，沉淀经验和知识，便于团队学习和传承'
            },
            {
              name: '版本控制',
              description: '自动管理资料版本，确保团队使用最新版本，避免信息混乱'
            }
          ],
          advantage: '智能化的资料管理系统，让销售人员能够快速找到所需资料，提升工作效率。'
        },
        promotion: {
          title: '营销宣传',
          overview: 'AI生成公众号软文、视频号内容，自动化内容创作和发布，提升品牌曝光度',
          functions: [
            {
              name: '公众号软文创作',
              description: 'AI智能生成高质量公众号文章，包括产品介绍、行业观点、案例分析等'
            },
            {
              name: '视频内容制作',
              description: '自动生成视频号内容，包括产品演示、教程视频、宣传片等'
            },
            {
              name: '内容发布管理',
              description: '定时发布内容，管理发布计划，确保营销活动的连续性'
            },
            {
              name: '传播效果分析',
              description: '分析内容传播效果，监控阅读量、点赞数、转发数等关键指标'
            }
          ],
          advantage: '结合AI创作能力，产出高质量的营销内容，大幅提升品牌曝光度。'
        },
        sop: {
          title: '标准化流程',
          overview: '制定销售SOP标准操作指南，规范销售流程，从客户开发到成交签单的全流程管理',
          functions: [
            {
              name: '客户开发流程',
              description: '标准化客户开发流程，从线索获取到初步接触的完整操作指南'
            },
            {
              name: '需求挖掘方法',
              description: '提供系统化的需求挖掘方法和工具，帮助销售人员深入了解客户需求'
            },
            {
              name: '产品推荐策略',
              description: '基于客户需求匹配最适合的产品解决方案，提高成交概率'
            },
            {
              name: '异议处理技巧',
              description: '整理常见客户异议及应对方法，提供标准化的异议处理流程'
            },
            {
              name: '成交签单流程',
              description: '规范成交签单流程，包括合同准备、价格谈判、签约等环节'
            },
            {
              name: '流程监控优化',
              description: '实时监控销售流程执行情况，分析瓶颈环节，持续优化流程'
            }
          ],
          advantage: '基于最佳销售实践的标准化流程，确保每个销售人员都能按照最优方法工作，大幅提升团队整体表现。'
        }
      }
    }
  },
  computed: {
    selectedModule() {
      return this.moduleData[this.selectedModuleKey] || {}
    }
  },
  methods: {
    getFunctionIcon(name) {
      const iconMap = {
        '行业信息搜索': '🔍',
        '客户信息挖掘': '👥',
        '竞争对手分析': '🏢',
        '供应链信息': '🔗',
        '供应商资源': '🏭',
        '展会信息汇总': '📅',
        '客户画像分析': '🎯',
        '推广资料定制': '📝',
        '邮件营销': '📧',
        '短信推广': '📱',
        '电话营销支持': '📞',
        '销售资料整理': '📋',
        '产品资料库': '🛍️',
        '行业信息汇总': '📊',
        '智能搜索': '🔍',
        '知识库管理': '📚',
        '版本控制': '🔄',
        '公众号软文创作': '✍️',
        '视频内容制作': '🎬',
        '内容发布管理': '📅',
        '传播效果分析': '📈',
        '客户开发流程': '🎯',
        '需求挖掘方法': '🔍',
        '产品推荐策略': '💡',
        '异议处理技巧': '❓',
        '成交签单流程': '✅',
        '流程监控优化': '📊'
      }
      return iconMap[name] || '📌'
    },
    openModal(moduleKey) {
      // this.selectedModuleKey = moduleKey
      // this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.selectedModuleKey = ''
    }
  },
  mounted() {
    document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0
    // 监听ESC键关闭弹窗
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.showModal) {
        this.closeModal()
      }
    })
  }
}
</script>

<style scoped>
.ai-sales-assistant {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  /* background: linear-gradient(135deg, #b2dfdb 0%, #80cbc4 50%, #4db6ac 100%); */
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.header {
  text-align: center;
  margin-bottom: 40px;
  color: rgb(0, 0, 0);
}

.header h1 {
  font-size: 2.5em;
  font-weight: 300;
  margin-bottom: 10px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.header p {
  font-size: 1.2em;
  opacity: 0.9;
}

.modules-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.module-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  backdrop-filter: blur(10px);
}

.module-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.module-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  font-weight: bold;
}

/* .module-icon.market { background: linear-gradient(135deg, #667eea, #764ba2); }
.module-icon.sales { background: linear-gradient(135deg, #f093fb, #f5576c); }
.module-icon.service { background: linear-gradient(135deg, #4facfe, #00f2fe); }
.module-icon.materials { background: linear-gradient(135deg, #43e97b, #38f9d7); }
.module-icon.promotion { background: linear-gradient(135deg, #fa709a, #fee140); } */
.module-icon.market { background: linear-gradient(135deg, #a8edea, #fed6e3); }
.module-icon.sales { background: linear-gradient(135deg, #a8edea, #fed6e3); }
.module-icon.service { background: linear-gradient(135deg, #a8edea, #fed6e3); }
.module-icon.materials { background: linear-gradient(135deg, #a8edea, #fed6e3); }
.module-icon.promotion { background: linear-gradient(135deg, #a8edea, #fed6e3); }
.module-icon.sop { background: linear-gradient(135deg, #a8edea, #fed6e3); }



.module-title {
  font-size: 1.5em;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.module-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  padding: 5px 0;
  color: #555;
  position: relative;
  padding-left: 20px;
}

.feature-list li:before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #4CAF50;
  font-weight: bold;
}

/* 修改弹窗样式 */
.modal {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: #fff;
  padding: 0;
  border-radius: 12px;
  width: 90%;
  max-width: 1000px;
  max-height: 90vh;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  animation: modalSlideIn 0.3s ease;
  display: flex;
  flex-direction: column;
}

@keyframes modalSlideIn {
  from { transform: translateY(-50px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.modal-header {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px 30px;
  border-radius: 12px 12px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.modal-title {
  font-size: 1.5em;
  font-weight: 500;
  color: #333;
}

.close {
  color: #666;
  font-size: 24px;
  font-weight: normal;
  cursor: pointer;
  transition: opacity 0.3s ease;
  opacity: 0.8;
}

.close:hover {
  opacity: 1;
}

.modal-body {
  padding: 20px 30px;
  overflow-y: auto;
  flex: 1;
}

.function-overview {
  color: #666;
  margin-bottom: 15px;
  line-height: 1.8;
  font-size: 1.1em;
  text-align: center;
}

.core-functions {
  margin-bottom: 15px;
}

.core-functions h3 {
  color: #333;
  margin-bottom: 20px;
  font-size: 1.3em;
  text-align: center;
}

.function-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin: 0 auto;
}

.function-item {
  background: rgba(245, 247, 250, 0.8);
  padding: 20px;
  border-radius: 8px;
  border-left: 3px solid #c3cfe2;
  transition: all 0.3s ease;
  display: flex;
  align-items: flex-start;
}

.function-item:hover {
  background: rgba(195, 207, 226, 0.1);
  transform: translateY(-2px);
}

.function-icon {
  font-size: 1.2em;
  margin-right: 10px;
  color: #3498db;
  min-width: 24px;
  text-align: center;
}

.function-content {
  flex: 1;
}

.function-item h4 {
  color: #333;
  margin-bottom: 10px;
  font-size: 1.1em;
}

.function-item p {
  color: #666;
  font-size: 0.95em;
  line-height: 1.6;
}

.core-advantage {
  background: rgba(245, 247, 250, 0.8);
  padding: 25px;
  border-radius: 8px;
  margin-top: 30px;
  margin-bottom: 15px;
  border-left: 3px solid #c3cfe2;
}

.core-advantage h3 {
  color: #333;
  margin-bottom: 15px;
  font-size: 1.3em;
}

.core-advantage p {
  color: #666;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .modules-grid {
    grid-template-columns: 1fr;
  }
  
  .modal-content {
    width: 95%;
    max-height: 95vh;
  }
  
  .modal-body {
    padding: 20px;
  }
  
  .function-grid {
    grid-template-columns: 1fr;
  }
}
</style>